import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-rating-and-review',
  templateUrl: './rating-and-review.component.html',
  styleUrls: ['./rating-and-review.component.scss']
})
export class RatingAndReviewComponent implements OnInit {
  public onClose: Subject<any>;
  public okBtnText: string;
  public cancelBtnText: string;
  rating: string;
  review: string;
  postType: string;
  postId: string;
  title: string;
  max: any;
  rated: boolean = false;
  constructor(public bsModalRef: BsModalRef) {}

  public ngOnInit(): void {
    this.onClose = new Subject();
    if (this.rating != null) {
     this.rated = true;
    }
  }

  public onConfirm(): void {
    const data = {
      rating: this.rating,
      review: this.review,
      postType: this.postType,
      postId: this.postId
    };
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/layout/rating-and-review/rating-and-review.component.ts